import { apiServer } from "../config/config";
import { AddPhotoImageData } from "../types";
import { fetchWithToken } from "./fetchWithToken";

export async function createVenueNote({
  businessId,
  title,
  note,
  notePriority,
  noteAreaType,
  noteAreaId,
  dateFrom,
  dateTo,
  business_note_heading_suggestions_id,
  placeholder_text,
  token,
}: {
  businessId: string;
  title: string;
  note: string;
  notePriority: string;
  noteAreaType: string;
  noteAreaId: string;
  dateFrom: string;
  dateTo: string;
  business_note_heading_suggestions_id?: string;
  placeholder_text?: string;
  token: string;
}) {
  const formData = new FormData();
  formData.append("business_id", businessId);
  formData.append("title", title);
  formData.append("notes", note);
  formData.append("business_notes_action_id", notePriority);
  formData.append("location_details[0][location_type]", noteAreaType);
  formData.append("location_details[0][location_id]", noteAreaId);
  formData.append("schedule_date_from", dateFrom);
  formData.append("schedule_date_to", dateTo);
  
  // Add new fields if provided
  if (business_note_heading_suggestions_id) {
    formData.append("business_note_heading_suggestions_id", business_note_heading_suggestions_id);
  }
  if (placeholder_text) {
    formData.append("placeholder_text", placeholder_text);
  }

  console.log(formData);
  const response = await fetchWithToken(
    `${apiServer}/business/create-venue-note`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response) {
    return null;
  }
  const responseData = await response.json();
  console.log(responseData);
  return responseData;
}

export async function deleteNote({
  noteId,
  token,
}: {
  noteId: string;
  token: string;
}) {
  const formData = new FormData();
  formData.append("note_id", noteId);
  const response = await fetchWithToken(
    `${apiServer}/business/delete-venue-note`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response) {
    return null;
  }
  const responseData = await response.json();
  console.log(responseData);
  return responseData;
}

export async function updateVenueNote({
  noteId,
  businessId,
  title,
  note,
  notePriority,
  noteAreaType,
  noteAreaId,
  dateFrom,
  dateTo,
  business_note_heading_suggestions_id,
  placeholder_text,
  token,
}: {
  noteId: string;
  businessId: string;
  title: string;
  note: string;
  notePriority: string;
  noteAreaType: string;
  noteAreaId: string;
  dateFrom: string;
  dateTo: string;
  business_note_heading_suggestions_id?: string;
  placeholder_text?: string;
  token: string;
}) {
  const formData = new FormData();
  formData.append("business_note_id", noteId);
  formData.append("business_id", businessId);
  formData.append("title", title);
  formData.append("notes", note);
  formData.append("business_notes_action_id", notePriority);
  formData.append("location_details[0][location_type]", noteAreaType);
  formData.append("location_details[0][location_id]", noteAreaId);
  formData.append("schedule_date_from", dateFrom);
  formData.append("schedule_date_to", dateTo);
  
  // Add new fields if provided
  if (business_note_heading_suggestions_id) {
    formData.append("business_note_heading_suggestions_id", business_note_heading_suggestions_id);
  }
  if (placeholder_text) {
    formData.append("placeholder_text", placeholder_text);
  }

  console.log(formData);
  const response = await fetchWithToken(
    `${apiServer}/business/update-venue-note`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response) {
    return null;
  }
  const responseData = await response.json();
  console.log(responseData);
  return responseData;
}

export async function resolveMapperNote({
  noteId,
  businessId,
  token,
}: {
  noteId: string;
  businessId: string;
  token: string;
}) {
  const formData = new FormData();
  formData.append("note_id", noteId);
  formData.append("business_id", businessId);

  const response = await fetchWithToken(
    `${apiServer}/business/resolve-venue-note`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  if (!response) {
    return null;
  }
  const responseData = await response.json();
  return responseData;
}

export async function flagNote({
  noteId,
  text,
  photos,
  token,
}: {
  noteId: string;
  text: string;
  photos: AddPhotoImageData[];
  token: string;
}) {
  try {
    const formData = new FormData();
    formData.append("business_note_id", noteId);
    formData.append("notes", text);
    formData.append("image", photos.length.toString());
    for (let i = 0; i < photos.length; i++) {
      const imageUri = photos[i].imageUrl;
      const fileName = `image${i}.jpg`;

      // Convert the base64 image to a Blob
      const response = await fetch(imageUri);
      const blob = await response.blob();

      formData.append(`image${i}`, blob, fileName);
    }

    console.log(formData);
    const response = await fetchWithToken(
      `${apiServer}/business/business-notes/flag`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response?.json();

    if (data.status === "error") {
      console.log(data);
      return data.message;
    } else {
      return data;
    }
  } catch (error: any) {
    console.log(error);
    return error.message;
  }
}
